import React, { useState } from "react";
import {
  FaMobile,
  FaRegEnvelope,
  FaRegUser,
  FaUserCircle,
} from "react-icons/fa";
import { FiKey } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";

import Customform from "../ui/custom-form";
import CustomInput from "../ui/custom-input";
import Header from "../Header/Header";
import { Signupapi } from "../../utility/api";

const Signup = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();

    const payload = {
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
      role,
      phoneNumber,
    };
    try {
      const response = await Signupapi(payload);

      if (response.status) {
        //console.log("Signup successful:", response);

        setEmail("");
        setPassword("");
        setFirstName("");
        setLastName("");
        setConfirmPassword("");
        navigate("/login");
      } else {
        console.error("Signup error:", response.message);
      }
    } catch (error) {
      console.error("Error during signup:", error);
    }
  };

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <div className="login-container">
          <div className="login-form">
            <h3
              className="text-center my-4 position-relative title"
              style={{ fontSize: "30px" }}
            >
              Signup
            </h3>
            <div className="px-md-3 px-lg-4 px-xl-5 mt-4">
              <Customform onSubmit={handleSignup}>
                <div className="form-group mb-3 inputWithIcon">
                  <span className="icon">
                    <FaRegUser />
                  </span>
                  <CustomInput
                    placeholder="Your first name"
                    name="firstName"
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>

                <div className="form-group mb-3 inputWithIcon">
                  <span className="icon">
                    <FaRegUser />
                  </span>
                  <CustomInput
                    placeholder="Your last name"
                    name="lastName"
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3 inputWithIcon">
                  <span className="icon">
                    <FaRegEnvelope />
                  </span>
                  <CustomInput
                    placeholder="Your email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3 inputWithIcon">
                  <span className="icon">
                    <FaMobile />
                  </span>
                  <CustomInput
                    placeholder="Your phone number"
                    name="phoneNumber"
                    type="text"
                    value={phoneNumber}
                    onChange={(e) => setphoneNumber(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3 inputWithIcon">
                  <span className="icon">
                    <FaUserCircle />
                  </span>
                  <CustomInput
                    placeholder="Your role"
                    name="role"
                    type="text"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  />
                </div>
                <div className="form-group mb-4 inputWithIcon">
                  <span className="icon">
                    <FiKey />
                  </span>
                  <CustomInput
                    placeholder="Your password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="form-group mb-4 inputWithIcon">
                  <span className="icon">
                    <FiKey />
                  </span>
                  <CustomInput
                    placeholder="confirm password"
                    name="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <button
                  type="submit"
                  className="btn btnLogin btn-primary text-center mt-4"
                >
                  Sign Up
                </button>
                <p className="alreadyAccount text-center my-3">
                  Already have an account? <Link to="/login">Log In</Link>
                </p>
              </Customform>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
